import { render, staticRenderFns } from "./groupChatDia.vue?vue&type=template&id=d9f96764&scoped=true&"
import script from "./groupChatDia.vue?vue&type=script&lang=js&"
export * from "./groupChatDia.vue?vue&type=script&lang=js&"
import style0 from "./groupChatDia.vue?vue&type=style&index=0&id=d9f96764&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9f96764",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/01-qym-hop-newmall-frontend-k8s@3/mgr-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d9f96764')) {
      api.createRecord('d9f96764', component.options)
    } else {
      api.reload('d9f96764', component.options)
    }
    module.hot.accept("./groupChatDia.vue?vue&type=template&id=d9f96764&scoped=true&", function () {
      api.rerender('d9f96764', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/group/components/newGroupChat/groupChatDia.vue"
export default component.exports